angular.module('bmsApp.sm.job')
	.controller('SMJobCloseListCtrl', [
		'$log',
		'$state',
		'$scope',
		'$localStorage',
		'SMJobSvc',
		'$filter',
		'LicenseOptionsSvc',
		'$q',
		function ($log,
				  $state,
				  $scope,
				  $localStorage,
				  SMJobSvc,
				  $filter,
				  LicenseOptionsSvc,
				  $q) {

			function init() {
				self.dateRangeOptions = $scope.config.datePicker.range;
				self.dateRangeOptions.options.format = $scope.config.format.date.amShortDate;
				self.dateRangeOptions.options.opens = 'left';
				delete self.dateRangeOptions.options.ranges.Today;
				delete self.dateRangeOptions.options.ranges.Yesterday;
				let params = null;
				if (angular.isDefined($localStorage.smJobCloseIndexParams)) {
					params = $localStorage.smJobCloseIndexParams;
					self.filterOptions = params.filter;
				}

				var promises = {
					licenseOptions: LicenseOptionsSvc.license(),
					licenceTypeOptions: LicenseOptionsSvc.network(),
				};
				$q.all(promises)
					.then(function (response) {
						$scope.licenseOptions = response.licenseOptions.data.options;
						$scope.licenseTypeOptions = response.licenceTypeOptions.data.options;
						$scope.loading = false;
					});

				getJobs(params);
			}

			function changeDate() {
				getJobs();
			}

			function changeOrder() {
				getJobs();
			}

			function filterApply() {
				self.params.page = 1;
				getJobs();
			}

			function filterReset() {
				self.filterOptions = {
					dateRange: {
						startDate: moment()
							.subtract(1, 'month')
							.format(),
						endDate: moment()
							.format()
					},
					order: "asc",
					unclosed: false,
					search: ""
				};
			}

			function getJobs(param) {
				var closedOnly = (self.filterOptions.unclosed) ? true : null;

				if (!self.loading) {
					self.loading = true;
					let params = null;
					if (angular.isObject(param)) {
						params = param;
					}
					else {
						params = {
							page: self.params.page,
							count: self.params.count,
							sorting: {
								last_visit_date: self.filterOptions.order
							},
							filter: {
								converted: true,
								lastVisitInPast: true,
								dateRange: self.filterOptions.dateRange,
								openOnly: closedOnly,
								search: self.filterOptions.search,
								licences: self.filterOptions.licences,
								licenceType: self.filterOptions.licenceType,
							}
						};
					}
					// if (!params.filter.unclosed) {
					// 	params.filter.unclosed = null;
					// }
					$localStorage.smJobCloseIndexParams = params;
					SMJobSvc.index(params)
						.then(function (response) {
							self.jobsTotal = response.data.sm_job_total_count;
							self.jobDates = $filter('groupBy')(response.data.sm_job_collection, 'last_visit_date');
							self.loading = false;

							// Check if we've exceeded our page size, if we have, go back
							if (response.data.sm_job_total_count > 0 && !response.data.sm_job_collection.length) {
								self.params.page = 1;
								getJobs();
							}

							//emit data to the sidebar
							// $scope.$emit("CloseJobListSideData", {
							// 	"totalVisits": self.visitsTotal,
							// 	"visits": self.visitDates,
							// 	"params": self.params
							// });
						});
				}
			}


			var self = $scope.SMCloseJobListCtrl = {
				methods: {
					init: init,
					changeDate: changeDate,
					changeOrder: changeOrder,
					filterApply: filterApply,
					filterReset: filterReset,
					getJobs: getJobs
				},
				filterOptions: {
					dateRange: {
						startDate: moment()
							.subtract(1, 'month')
							.format(),
						endDate: moment()
							.format()
					},
					order: "asc",
					unclosed: false,
					search: "",
					licences: null,
					licenceType: null,
				},
				visitDates: [],
				licenses: {},
				dateRangeOptions: null,
				shortInfo: {
					closed: 0
				},
				window: 0,
				params: {
					page: 1,
					count: 50,
				},
				visitsTotal: 0,
				loading: false,
				jobTimeout: 800
			};

		}
	]);